import { SIZE_10MO_OCTETS, useTextes } from "@common/config";
import { Z_SAVED_FILE } from "@common/schemas";
import { z } from "zod";

const t = useTextes('ParcoursOfa', 'Campagne');

export const depotDeclarationFormSchema = z.object({
  etablissementDeclarant: z.string(),
  declaration: Z_SAVED_FILE({ errorMsg: t['DEPOT_FICHIER_TEXTE1'], maxSize: SIZE_10MO_OCTETS }),
});